import { ReactDOM } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

function CarouselMegaStrike() {
  return (
    <Carousel>
      <div>
        <img
          src="img/megaStrike/MS-01.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-02.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-03.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-04.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-05.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-06.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-07.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-08.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-09.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-10.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-11.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-12.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-13.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-14.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
      <div>
        <img
          src="img/megaStrike/MS-15.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Natali Larroza"
          id="imgCarousel"
        />
        <p className="legend">Print Design</p>
      </div>
    </Carousel>
  );
}

export default CarouselMegaStrike;
